import { useState } from 'react';
import * as React from 'react';

import useEnterpriseMegaMenuLinks, {
  useEnterpriseOrgScopedMenuLinks,
} from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import ExploreSubPage from 'bundles/composable-page-header/components/mobile-menu-items/ExploreSubPage';
import type { MobileExploreIdentifierValues } from 'bundles/composable-page-header/constants';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';
import type { MenuItem } from 'bundles/megamenu/types/MenuData';

type Props = {
  identifier: MobileExploreIdentifierValues;
};

const EnterpriseExploreSubmenuWrapper = ({ identifier }: Props) => {
  const [exploreViewState, setExploreViewState] = useState<MobileExploreIdentifierValues>(identifier);
  const [currentMenuItem, setMenuItem] = useState<MenuItem | undefined>(undefined);
  const isOrgScopedHome = GrowthDiscoveryEpicClient.preview('orgScopedHome');
  const orgScopedLinks = useEnterpriseOrgScopedMenuLinks();
  const megaMenuLinks = useEnterpriseMegaMenuLinks();
  const links = isOrgScopedHome ? orgScopedLinks : megaMenuLinks;

  return (
    <MegaMenuLinksProvider links={links} isEnterprise>
      <ExploreSubPage
        exploreViewState={exploreViewState}
        setExploreViewState={setExploreViewState}
        setMenuItem={setMenuItem}
        currentMenuItem={currentMenuItem}
      />
    </MegaMenuLinksProvider>
  );
};

export default EnterpriseExploreSubmenuWrapper;
